(function () {
  'use strict';

  /* ---------- Compte à rebours saison -------------------------------- */
  (function () {
    var el = document.getElementById('season');
    var out = document.getElementById('seasonText');
    if (!el || !out) return;

    var cfg = window.VANTAGE_SEASON || {};
    var evName = cfg.event || 'Partridge season';
    var openMonth = (cfg.month || 9) - 1;   // 1-12 -> 0-11
    var openDay = cfg.day || 1;
    var endMonth = (cfg.endMonth || 2) - 1;
    var endDay = cfg.endDay || 1;

    var now = new Date();
    var year = now.getFullYear();
    var opening = new Date(year, openMonth, openDay);
    var today = new Date(year, now.getMonth(), now.getDate());

    var seasonEnd = new Date(year + 1, endMonth, endDay);
    if (today >= seasonEnd) { opening = new Date(year + 1, openMonth, openDay); }

    var days = Math.round((opening - today) / 86400000);

    if (days > 1) {
      out.innerHTML = evName + ' opens in <b>' + days + '</b> days';
    } else if (days === 1) {
      out.innerHTML = evName + ' opens <b>tomorrow</b>';
    } else if (days === 0) {
      out.innerHTML = evName + ' opens <b>today</b>';
    } else {
      out.innerHTML = evName + ' is <b>open</b>';
    }
    el.removeAttribute('hidden');
  })();

  /* ---------- Menu mobile -------------------------------------------- */
  var burger = document.getElementById('burger');
  var mnav = document.getElementById('mobileNav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    mnav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        mnav.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- FAQ accordéon ------------------------------------------- */
  Array.prototype.forEach.call(document.querySelectorAll('.faq-q'), function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var panel = item.querySelector('.faq-a');
      var isOpen = item.classList.contains('open');

      Array.prototype.forEach.call(document.querySelectorAll('.faq-item.open'), function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-a').style.maxHeight = null;
        o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  if (window.VANTAGE_FAQ_OPEN_FIRST !== false) {
    var first = document.querySelector('.faq-q');
    if (first) first.click();
  }

  /* ---------- Quiz "Find your camera in 60 seconds" ------------------- */
  var QUESTIONS = window.VANTAGE_QUIZ || [
    {
      q: 'Where is this camera going to live?',
      opts: [
        { t: 'Somewhere exposed',  s: 'Near a track, gate or footpath — people walk past it',      score: { spotter: 3, watch: 0, overwatch: 0 } },
        { t: 'Hidden, but reachable', s: 'A crossing point off the beaten path I can get to',      score: { spotter: 1, watch: 3, overwatch: 1 } },
        { t: 'The far end of the ground', s: 'A block I would rather not drive out to at all',     score: { spotter: 0, watch: 1, overwatch: 3 } }
      ]
    },
    {
      q: 'What is the mobile signal like out there?',
      opts: [
        { t: 'Non-existent',   s: 'It drops the second I leave the village',   score: { spotter: 3, watch: 0, overwatch: 0 } },
        { t: 'Patchy but there', s: 'A bar or two if I stand in the right spot', score: { spotter: 1, watch: 3, overwatch: 2 } },
        { t: 'Perfectly fine', s: 'Full signal across the whole permission',    score: { spotter: 0, watch: 3, overwatch: 3 } }
      ]
    },
    {
      q: 'How often can you realistically get back to it?',
      opts: [
        { t: 'Most weeks',        s: 'It is on my way, changing cards is no bother', score: { spotter: 3, watch: 1, overwatch: 0 } },
        { t: 'Every ten days or so', s: 'The usual rhythm — I try not to pressure the ground', score: { spotter: 1, watch: 3, overwatch: 2 } },
        { t: 'Once a month at best', s: 'Long drive. I want to set it and forget it',  score: { spotter: 0, watch: 1, overwatch: 3 } }
      ]
    }
  ];

  var TIERS = window.VANTAGE_TIERS || {
    spotter: {
      name: 'Spotter',
      href: '#spotter',
      lens: '#6E7A74', led: '#4A5450',
      why: 'Cheap on purpose, not cheap in build. Runs on its SD card with zero signal, so it keeps working where the network gives up — and if it does walk, you are out £49, not £169.'
    },
    watch: {
      name: 'Watch',
      href: '#watch',
      lens: '#C98C42', led: '#7C5A2E',
      why: 'The key camera. 0.19s trigger, images on your phone the moment they are taken, SIM and data included in the price with nothing to cancel. Hide it on the crossing that actually informs your decisions.'
    },
    overwatch: {
      name: 'Overwatch',
      href: '#overwatch',
      lens: '#C98C42', led: '#C98C42',
      why: 'Built for ground you would rather not visit. Solar panel and a 128GB card included, so you can set it before the season and leave it alone until it is over — without a single battery run.'
    }
  };

  var elQ = document.getElementById('quizQ');
  var elOpts = document.getElementById('quizOpts');
  var elStep = document.getElementById('quizStep');
  var elBar = document.getElementById('quizBar');
  var elBody = document.getElementById('quizBody');
  var elResult = document.getElementById('quizResult');
  var elBack = document.getElementById('quizBack');

  if (elQ && elOpts && elStep && elBar && elBody && elResult && elBack) {
    var idx = 0;
    var picked = [];

    var render = function () {
      var item = QUESTIONS[idx];
      elQ.textContent = item.q;
      elStep.textContent = 'Question ' + (idx + 1) + ' of ' + QUESTIONS.length;
      elBar.style.width = ((idx + 1) / QUESTIONS.length * 100) + '%';
      elOpts.innerHTML = '';
      if (idx > 0) { elBack.removeAttribute('hidden'); } else { elBack.setAttribute('hidden', ''); }

      item.opts.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'quiz-opt';
        var strong = document.createElement('b');
        strong.textContent = o.t;
        var span = document.createElement('span');
        span.textContent = o.s;
        b.appendChild(strong);
        b.appendChild(span);
        b.addEventListener('click', function () {
          picked[idx] = o;
          picked.length = idx + 1;
          idx++;
          if (idx < QUESTIONS.length) { render(); } else { finish(); }
        });
        elOpts.appendChild(b);
      });
    };

    var finish = function () {
      var score = { spotter: 0, watch: 0, overwatch: 0 };
      picked.forEach(function (o) {
        for (var k in o.score) { score[k] += o.score[k]; }
      });

      var best = 'watch';
      Object.keys(score).forEach(function (k) { if (score[k] > score[best]) best = k; });
      var tier = TIERS[best];

      document.getElementById('rName').textContent = tier.name;
      document.getElementById('rWhy').textContent = tier.why;
      document.getElementById('rLink').setAttribute('href', tier.href);

      document.getElementById('rRecap').innerHTML =
        picked.map(function (o) { return '<b>' + o.t + '</b>'; }).join(' &nbsp;·&nbsp; ');

      var cam = document.getElementById('rCam');
      cam.style.setProperty('--lens', tier.lens);
      cam.style.setProperty('--led', tier.led);

      elBody.style.display = 'none';
      elResult.classList.add('show');
      elStep.textContent = 'Your match';
    };

    elBack.addEventListener('click', function () {
      if (idx > 0) { idx--; render(); }
    });

    document.getElementById('quizReset').addEventListener('click', function () {
      idx = 0;
      picked = [];
      elResult.classList.remove('show');
      elBody.style.display = '';
      render();
    });

    render();
  }

  /* ---------- Bascule Jour / Nuit -------------------------------------- */
  function swapMedia(frame, night) {
    var media = frame.querySelector('.nv-media');
    if (!media) return;

    var src = media.getAttribute(night ? 'data-night' : 'data-day');
    if (!src || media.getAttribute('src') === src) return;

    frame.classList.add('is-swapping');

    var poster = media.getAttribute(night ? 'data-night-poster' : 'data-day-poster');
    if (poster) { media.setAttribute('poster', poster); }

    var alt = media.getAttribute(night ? 'data-night-alt' : 'data-day-alt');
    if (alt) { media.setAttribute('alt', alt); }

    media.setAttribute('src', src);

    if (media.tagName === 'VIDEO') {
      media.load();
      var p = media.play();
      if (p && p.catch) { p.catch(function () {}); }
      frame.classList.remove('is-swapping');
    } else {
      if (media.decode) {
        media.decode().then(function () { frame.classList.remove('is-swapping'); })
                      .catch(function () { frame.classList.remove('is-swapping'); });
      } else {
        media.onload = function () { frame.classList.remove('is-swapping'); };
      }
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('.nv-switch'), function (sw) {
    var targets = document.querySelectorAll(sw.getAttribute('data-nv-target'));
    var buttons = sw.querySelectorAll('button[data-nv-mode]');

    Array.prototype.forEach.call(buttons, function (btn) {
      btn.addEventListener('click', function () {
        var night = btn.getAttribute('data-nv-mode') === 'night';

        Array.prototype.forEach.call(buttons, function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        Array.prototype.forEach.call(targets, function (frame) {
          frame.dataset.mode = night ? 'night' : 'day';
          swapMedia(frame, night);
        });
        tick();
      });
    });
  });

  /* Horodatage HUD */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var secs = pad(new Date().getSeconds());

    Array.prototype.forEach.call(document.querySelectorAll('.nv-frame'), function (frame) {
      var out = frame.querySelector('.nv-clock');
      if (!out) return;
      var night = frame.dataset.mode === 'night';
      var t = frame.getAttribute(night ? 'data-night-time' : 'data-day-time');
      out.textContent = (t || (night ? '04:17' : '17:42')) + ':' + secs;
    });
  }
  tick();
  setInterval(tick, 1000);

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    Array.prototype.forEach.call(document.querySelectorAll('.nv-media'), function (media) {
      if (media.tagName !== 'VIDEO') return;
      media.removeAttribute('autoplay');
      media.setAttribute('controls', '');
      media.pause();
    });
  }

  /* ---------- Navigation : pastille laiton sur la section courante ------ */
  var navLinks = document.querySelectorAll('.nav a[href^="#"], .mobile-nav a[href^="#"]');

  function setActive(hash) {
    Array.prototype.forEach.call(navLinks, function (a) {
      a.classList.toggle('is-active', a.getAttribute('href') === hash);
    });
  }

  Array.prototype.forEach.call(navLinks, function (a) {
    a.addEventListener('click', function () { setActive(a.getAttribute('href')); });
  });

  var spied = [];
  Array.prototype.forEach.call(navLinks, function (a) {
    var id = a.getAttribute('href').slice(1);
    var section = document.getElementById(id);
    if (section && spied.indexOf(section) === -1) { spied.push(section); }
  });

  if ('IntersectionObserver' in window && spied.length) {
    var visible = {};
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { visible[entry.target.id] = entry.isIntersecting; });

      for (var i = 0; i < spied.length; i++) {
        if (visible[spied[i].id]) { setActive('#' + spied[i].id); return; }
      }
      setActive(null);
    }, { rootMargin: '-45% 0px -50% 0px' });

    spied.forEach(function (s) { spy.observe(s); });
  }

  /* ---------- Bulle assistant ---------- */
  var assistantClose = document.getElementById('assistantClose');
  if (assistantClose) {
    assistantClose.addEventListener('click', function (e) {
      e.stopPropagation();
      document.getElementById('assistant').setAttribute('hidden', '');
    });
  }
})();
